import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'mtn-analytics-error-state',
  templateUrl: './analytics-error-state.component.html',
  styleUrls: ['./analytics-error-state.component.scss']
})
export class AnalyticsErrorStateComponent {
  @Output() tryAgain = new EventEmitter<void>();
  @Output() goBack = new EventEmitter<void>();

  onTryAgain(): void {
    this.tryAgain.emit();
  }

  onGoBack(): void {
    this.goBack.emit();
  }
}
